import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { screens, nextPage, displaySizeError } from 'actions/onboarding';
import Button from 'components/deprecated/legacyElements/Button';
import styles from './style.module.scss';

export class ProfileFooter extends PureComponent {
  static contextTypes = {
    router: PropTypes.any,
  };

  static propTypes = {
    activeScreenIndex: PropTypes.number.isRequired,
    nextPage: PropTypes.func.isRequired,
    displaySizeError: PropTypes.func.isRequired,
  };

  render() {
    const activeScreen = screens[this.props.activeScreenIndex] || screens[0];
    const canContinue = activeScreen.canContinue
      ? activeScreen.canContinue(this.props)
      : true;
    const { canSkip } = activeScreen;
    const nextButtonClass = `onboardingNextButton ${
      !canContinue ? 'disabled' : ''
    }`;
    const clickHandler =
      this.props.numEmployees < 1
        ? this.props.displaySizeError
        : this.props.nextPage;

    return (
      <footer className={styles.innerFooter}>
        {canSkip && (
          <Button type="button" secondary onClick={this.props.nextPage}>
            Skip
          </Button>
        )}
        <Button
          className={nextButtonClass}
          disabled={!canContinue}
          onClick={clickHandler}
        >
          {`${this.props.activeScreenIndex + 1} / ${screens.length} >`}
        </Button>
      </footer>
    );
  }
}

export default connect(
  (state) => ({
    ...state.onboarding,
  }),
  {
    nextPage,
    displaySizeError,
  }
)(ProfileFooter);
